<div class="host-channel-panel pb-[30px]">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "operate_sidebar_html_日期" | translate }}
      <!-- Date -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row justify-between">
          <host-range-picker
            class="flex-1 mr-5"
            [showFooter]="false"
            [size]="'large'"
            [disabledDate]="disabledDate"
            [(ngModel)]="dateRange"
            (ngModelChange)="changeDate($event)"></host-range-picker>
          <!-- <nz-range-picker
            class="range-picker flex-1 mr-5"
            nzSize="large"
            [nzFormat]="nzFormat"
            [nzDisabledDate]="disabledDate"
            [(ngModel)]="dateRange"
            (ngModelChange)="changeDate($event)"
            [nzDropdownClassName]="'host-operate-sidebar-date-picker'"
          ></nz-range-picker> -->
          <div class="extra">
            {{
              (nights > 1 ? "component.sidebar.plural.total_nights" : "component.sidebar.singular.total_nights")
                | translate
                  : {
                      nights: nights
                    }
            }}
            <!-- 共{{ nights }}晚 -->
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="item">-->
    <!--      <div class="control">-->
    <!--        <span class="gray-bg">{{ relatedHouse?.related?.title }}</span>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
  <div class="v4-layout-form" *ngIf="houseType === 0">
    <div class="v4-layout-form-title">{{ "component.sidebar.status_form_title_status" | translate }}</div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-label w-[240px] dark">
        {{ "component.sidebar.modify_together" | translate }}
        <!-- 一键修改 -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <host-radio-button
            class="radio-button"
            size="large"
            [options]="[
              { label: 'component.sidebar.status_on' | translate, value: 1 },
              { label: 'component.sidebar.status_off' | translate, value: 0 }
            ]"
            [(value)]="available"></host-radio-button>
        </div>
      </div>
    </div>
    <ng-container *ngFor="let data of listOfDataByThirdparty">
      <host-edit-status-form-item [data]="data" [active]="entity.c_id === data.unique_key"></host-edit-status-form-item>
    </ng-container>

    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <nz-alert nzShowIcon nzType="info" [nzMessage]="'warning.house_status_modify_again' | translate"></nz-alert>
      </div>
    </div>
  </div>

  <div class="v4-layout-form" *ngIf="houseType === 1">
    <div class="v4-layout-form-title">
      {{ "component.sidebar.channel_form_title_stock" | translate }}
      <!-- 库存 -->
      <!-- <span class="flow-right yellow">
        <i
          nz-icon
          nzType="info-circle"
          nzTheme="outline"></i>
        {{ "warning.inventory_modify_again" | translate }}
        库存可能会被百居易自动库存控制再次修改
      </span> -->
    </div>
    <div class="v4-layout-field">
      <span class="v4-layout-field-label flex-1">
        {{ "component.sidebar.modify_together" | translate }}
        <!-- 一键修改 -->
      </span>
      <div class="v4-layout-field-control !flex-none w-[120px]">
        <input
          type="text"
          nzSize="large"
          nz-input
          hostInputNumber
          [(ngModel)]="stock"
          [attr.placeholder]="'placeholder.input_new_inventory' | translate" />
      </div>
    </div>
    <ng-container *ngFor="let data of listOfDataByThirdparty">
      <host-edit-inventory-form-item
        [data]="data"
        [active]="entity.c_id === data.unique_key"></host-edit-inventory-form-item>
    </ng-container>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <nz-alert nzShowIcon nzType="info" [nzMessage]="'warning.inventory_modify_again' | translate"></nz-alert>
      </div>
    </div>
    <!--    <div-->
    <!--      class="item"-->
    <!--      *ngFor="let data of listOfDataByThirdparty">-->
    <!--      <span class="label">-->
    <!--        {{ "word.channel_" + data.thirdparty_type | translate }}-->
    <!--      </span>-->
    <!--      <div class="control">-->
    <!--        <input-->
    <!--          class="input"-->
    <!--          diffType="text"-->
    <!--          nz-input-->
    <!--          hostInputNumber-->
    <!--          [placeholder]="data.placeholder"-->
    <!--          [(ngModel)]="data.stock">-->

    <!--      </div>-->
    <!--    </div>-->
  </div>
  <!--  <span class="inventory-modify-tip">-->
  <!--    <i nz-icon nzType="info-circle" nzTheme="outline"></i>-->
  <!--    {{ "warning.inventory_modify_again" | translate }}-->
  <!--     库存可能会被百居易自动库存控制再次修改 -->
  <!--  </span>-->

  <footer class="bar-footer">
    <button nz-button nzSize="large" (click)="onClickCancel()">
      {{ "word.cancel" | translate }}
      <!-- 取消 -->
    </button>
    <button nz-button nzType="primary" nzSize="large" (click)="onClickSave()">
      {{ "word.save" | translate }}
      <!-- 保存 -->
    </button>
  </footer>
</div>
